// extracted by mini-css-extract-plugin
export default {"icon":"ProcoreComponent_icon__5yWnG","procore":"ProcoreComponent_procore__4q2R+"};